import isArray from 'lodash-es/isArray';
import isObject from 'lodash-es/isObject';
import isString from 'lodash-es/isString';
import reduce from 'lodash-es/reduce';
import set from 'lodash-es/set';
import startsWith from 'lodash-es/startsWith';

export function unflattenObjectKeys(object: any) {
  return reduce(object, (result, value, key) => set(result, key, value), {});
}

export function flattenObjectKeys(
  parentObject: any,
  keyPrefix = '',
  delimiter = '.',
): any {
  return Object.keys(parentObject).reduce((result: any, key: any) => {
    const parentValue = parentObject[key];
    if (!isObject(parentValue) || isArray(parentValue)) {
      return {
        ...result,
        [`${keyPrefix}${key}`]: parentValue,
      };
    }
    const flattenedChild = flattenObjectKeys(parentValue, '', delimiter);
    const combinedChildKeys = Object.keys(flattenedChild).reduce(
      (childResult, childKey) => {
        const childDelimiter = startsWith(childKey, delimiter) ? '' : delimiter;
        const keyName = `${keyPrefix}${key}${childDelimiter}${childKey}`;
        return { ...childResult, [keyName]: flattenedChild[childKey] };
      },
      {},
    );
    return { ...result, ...combinedChildKeys };
  }, {});
}
